"use client"

import {CustomerAuthenticatedScrollScope} from '@fitro/customer-features/components/providers/CustomerAuthenticatedScrollScope'
import type {ReactNode} from 'react'
import {preconnect, prefetchDNS} from 'react-dom'
import {ClerkAppProvider} from '@/components/providers/ClerkAppProvider'
import {TokenWarmup} from '@/components/providers/TokenWarmup'
import {GlobalErrorHandlers} from '@fitro/customer-features/components/providers/GlobalErrorHandlers'
import {AuthCacheResetBoundary} from '@/components/providers/AuthCacheResetBoundary'

export function AuthenticatedProviders({children, signedOutRequest}: {children: ReactNode, signedOutRequest?: boolean}) {
    preconnect('https://img.clerk.com', {crossOrigin: 'anonymous'})
    preconnect('https://images.clerk.dev', {crossOrigin: 'anonymous'})
    prefetchDNS('https://img.clerk.com')
    prefetchDNS('https://images.clerk.dev')

    return (
        <ClerkAppProvider signedOutRequest={signedOutRequest}>
            <CustomerAuthenticatedScrollScope/>
            <AuthCacheResetBoundary>
                <GlobalErrorHandlers />
                <TokenWarmup />
                {children}
            </AuthCacheResetBoundary>
        </ClerkAppProvider>
    )
}
